import React from 'react';
import styled, { keyframes } from 'styled-components';
import Card from 'components/Card';
import EnhancedThemeProvider from 'components/EnhancedThemeProvider';
import {
  Container,
  MetricsGrid,
  HeaderContainer,
  IconWrapper,
} from '../StyledComponents';

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const SkeletonBox = styled.div`
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'linear-gradient(to right, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.05) 100%)'
      : 'linear-gradient(to right, #f0f0f0 0%, #e0e0e0 50%, #f0f0f0 100%)'};
  background-size: 1000px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
  height: ${(props) => props.height || '16px'};
  width: ${(props) => props.width || '100%'};
`;

const SkeletonCard = styled(Card)`
  padding: 24px;
  min-height: 100px;
`;

const UsersSkeleton = () => {
  return (
    <EnhancedThemeProvider>
      <Container>
        {/* Header Skeleton */}
        <Card style={{ marginBottom: '30px' }}>
          <HeaderContainer>
            <IconWrapper>
              <SkeletonBox height="32px" width="32px" />
            </IconWrapper>
            <div style={{ flex: 1 }}>
              <SkeletonBox height="32px" width="120px" />
            </div>
          </HeaderContainer>
        </Card>

        {/* Metrics Skeleton */}
        <MetricsGrid>
          {[1, 2, 3, 4, 5].map((i) => (
            <SkeletonCard key={i}>
              <SkeletonBox
                height="14px"
                width="80px"
                style={{ marginBottom: '8px' }}
              />
              <SkeletonBox
                height="32px"
                width="60px"
                style={{ marginBottom: '8px' }}
              />
              <SkeletonBox height="12px" width="100px" />
            </SkeletonCard>
          ))}
        </MetricsGrid>

        {/* Search Skeleton */}
        <SkeletonCard style={{ marginBottom: '30px' }}>
          <SkeletonBox height="40px" width="100%" />
        </SkeletonCard>

        {/* Table Skeleton */}
        <SkeletonCard>
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} style={{ marginBottom: '16px' }}>
              <SkeletonBox height="20px" width="100%" />
            </div>
          ))}
        </SkeletonCard>
      </Container>
    </EnhancedThemeProvider>
  );
};

export default UsersSkeleton;
